import styled from 'styled-components';

export default styled.section`
  .cta-intro {
    padding-top: 6.8438rem;
    padding-bottom: 6.8438rem;

    .links {
      margin-top: 1.6563rem;
    }

    p {
      color: ${props => props.theme.colors.white};
    }
  }

  .additional-links {
    margin-top: 1rem;
    label {
      font-size: 1rem;
      color: ${props => props.theme.colors.grey1};
      margin-right: 1rem;
    }

    a {
      font-size: 0.875rem;
      font-weight: 700;
      color: ${props => props.theme.colors.claytonBlue};
    }
  }
`;
